import React, { useRef, useState, useEffect } from "react";
import "./candidateUpload.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { CANDIDATE_SOURCE } from "../../constants/candidateSource";
import { Alert, Dialog, Snackbar } from "@mui/material";
import {
  fetchJobById,
  applyForJob,
} from "../../Redux/ActionCreators/jobsAction";
import { fetchTenantBranding } from "../../Redux/ActionCreators/qualifyQuestionsAction";

const COUNTRY_CODES = [
  { code: "AF", dialCode: "+93",   name: "Afghanistan" },
  { code: "AL", dialCode: "+355",  name: "Albania" },
  { code: "DZ", dialCode: "+213",  name: "Algeria" },
  { code: "AD", dialCode: "+376",  name: "Andorra" },
  { code: "AO", dialCode: "+244",  name: "Angola" },
  { code: "AG", dialCode: "+1268", name: "Antigua and Barbuda" },
  { code: "AR", dialCode: "+54",   name: "Argentina" },
  { code: "AM", dialCode: "+374",  name: "Armenia" },
  { code: "AU", dialCode: "+61",   name: "Australia" },
  { code: "AT", dialCode: "+43",   name: "Austria" },
  { code: "AZ", dialCode: "+994",  name: "Azerbaijan" },
  { code: "BS", dialCode: "+1242", name: "Bahamas" },
  { code: "BH", dialCode: "+973",  name: "Bahrain" },
  { code: "BD", dialCode: "+880",  name: "Bangladesh" },
  { code: "BB", dialCode: "+1246", name: "Barbados" },
  { code: "BY", dialCode: "+375",  name: "Belarus" },
  { code: "BE", dialCode: "+32",   name: "Belgium" },
  { code: "BZ", dialCode: "+501",  name: "Belize" },
  { code: "BJ", dialCode: "+229",  name: "Benin" },
  { code: "BT", dialCode: "+975",  name: "Bhutan" },
  { code: "BO", dialCode: "+591",  name: "Bolivia" },
  { code: "BA", dialCode: "+387",  name: "Bosnia and Herzegovina" },
  { code: "BW", dialCode: "+267",  name: "Botswana" },
  { code: "BR", dialCode: "+55",   name: "Brazil" },
  { code: "BN", dialCode: "+673",  name: "Brunei" },
  { code: "BG", dialCode: "+359",  name: "Bulgaria" },
  { code: "BF", dialCode: "+226",  name: "Burkina Faso" },
  { code: "BI", dialCode: "+257",  name: "Burundi" },
  { code: "CV", dialCode: "+238",  name: "Cabo Verde" },
  { code: "KH", dialCode: "+855",  name: "Cambodia" },
  { code: "CM", dialCode: "+237",  name: "Cameroon" },
  { code: "CA", dialCode: "+1",    name: "Canada" },
  { code: "CF", dialCode: "+236",  name: "Central African Republic" },
  { code: "TD", dialCode: "+235",  name: "Chad" },
  { code: "CL", dialCode: "+56",   name: "Chile" },
  { code: "CN", dialCode: "+86",   name: "China" },
  { code: "CO", dialCode: "+57",   name: "Colombia" },
  { code: "KM", dialCode: "+269",  name: "Comoros" },
  { code: "CG", dialCode: "+242",  name: "Congo" },
  { code: "CR", dialCode: "+506",  name: "Costa Rica" },
  { code: "HR", dialCode: "+385",  name: "Croatia" },
  { code: "CU", dialCode: "+53",   name: "Cuba" },
  { code: "CY", dialCode: "+357",  name: "Cyprus" },
  { code: "CZ", dialCode: "+420",  name: "Czech Republic" },
  { code: "DK", dialCode: "+45",   name: "Denmark" },
  { code: "DJ", dialCode: "+253",  name: "Djibouti" },
  { code: "DM", dialCode: "+1767", name: "Dominica" },
  { code: "DO", dialCode: "+1809", name: "Dominican Republic" },
  { code: "EC", dialCode: "+593",  name: "Ecuador" },
  { code: "EG", dialCode: "+20",   name: "Egypt" },
  { code: "SV", dialCode: "+503",  name: "El Salvador" },
  { code: "GQ", dialCode: "+240",  name: "Equatorial Guinea" },
  { code: "ER", dialCode: "+291",  name: "Eritrea" },
  { code: "EE", dialCode: "+372",  name: "Estonia" },
  { code: "SZ", dialCode: "+268",  name: "Eswatini" },
  { code: "ET", dialCode: "+251",  name: "Ethiopia" },
  { code: "FJ", dialCode: "+679",  name: "Fiji" },
  { code: "FI", dialCode: "+358",  name: "Finland" },
  { code: "FR", dialCode: "+33",   name: "France" },
  { code: "GA", dialCode: "+241",  name: "Gabon" },
  { code: "GM", dialCode: "+220",  name: "Gambia" },
  { code: "GE", dialCode: "+995",  name: "Georgia" },
  { code: "DE", dialCode: "+49",   name: "Germany" },
  { code: "GH", dialCode: "+233",  name: "Ghana" },
  { code: "GR", dialCode: "+30",   name: "Greece" },
  { code: "GD", dialCode: "+1473", name: "Grenada" },
  { code: "GT", dialCode: "+502",  name: "Guatemala" },
  { code: "GN", dialCode: "+224",  name: "Guinea" },
  { code: "GW", dialCode: "+245",  name: "Guinea-Bissau" },
  { code: "GY", dialCode: "+592",  name: "Guyana" },
  { code: "HT", dialCode: "+509",  name: "Haiti" },
  { code: "HN", dialCode: "+504",  name: "Honduras" },
  { code: "HU", dialCode: "+36",   name: "Hungary" },
  { code: "IS", dialCode: "+354",  name: "Iceland" },
  { code: "IN", dialCode: "+91",   name: "India" },
  { code: "ID", dialCode: "+62",   name: "Indonesia" },
  { code: "IR", dialCode: "+98",   name: "Iran" },
  { code: "IQ", dialCode: "+964",  name: "Iraq" },
  { code: "IE", dialCode: "+353",  name: "Ireland" },
  { code: "IL", dialCode: "+972",  name: "Israel" },
  { code: "IT", dialCode: "+39",   name: "Italy" },
  { code: "JM", dialCode: "+1876", name: "Jamaica" },
  { code: "JP", dialCode: "+81",   name: "Japan" },
  { code: "JO", dialCode: "+962",  name: "Jordan" },
  { code: "KZ", dialCode: "+7",    name: "Kazakhstan" },
  { code: "KE", dialCode: "+254",  name: "Kenya" },
  { code: "KI", dialCode: "+686",  name: "Kiribati" },
  { code: "KW", dialCode: "+965",  name: "Kuwait" },
  { code: "KG", dialCode: "+996",  name: "Kyrgyzstan" },
  { code: "LA", dialCode: "+856",  name: "Laos" },
  { code: "LV", dialCode: "+371",  name: "Latvia" },
  { code: "LB", dialCode: "+961",  name: "Lebanon" },
  { code: "LS", dialCode: "+266",  name: "Lesotho" },
  { code: "LR", dialCode: "+231",  name: "Liberia" },
  { code: "LY", dialCode: "+218",  name: "Libya" },
  { code: "LI", dialCode: "+423",  name: "Liechtenstein" },
  { code: "LT", dialCode: "+370",  name: "Lithuania" },
  { code: "LU", dialCode: "+352",  name: "Luxembourg" },
  { code: "MG", dialCode: "+261",  name: "Madagascar" },
  { code: "MW", dialCode: "+265",  name: "Malawi" },
  { code: "MY", dialCode: "+60",   name: "Malaysia" },
  { code: "MV", dialCode: "+960",  name: "Maldives" },
  { code: "ML", dialCode: "+223",  name: "Mali" },
  { code: "MT", dialCode: "+356",  name: "Malta" },
  { code: "MH", dialCode: "+692",  name: "Marshall Islands" },
  { code: "MR", dialCode: "+222",  name: "Mauritania" },
  { code: "MU", dialCode: "+230",  name: "Mauritius" },
  { code: "MX", dialCode: "+52",   name: "Mexico" },
  { code: "FM", dialCode: "+691",  name: "Micronesia" },
  { code: "MD", dialCode: "+373",  name: "Moldova" },
  { code: "MC", dialCode: "+377",  name: "Monaco" },
  { code: "MN", dialCode: "+976",  name: "Mongolia" },
  { code: "ME", dialCode: "+382",  name: "Montenegro" },
  { code: "MA", dialCode: "+212",  name: "Morocco" },
  { code: "MZ", dialCode: "+258",  name: "Mozambique" },
  { code: "MM", dialCode: "+95",   name: "Myanmar" },
  { code: "NA", dialCode: "+264",  name: "Namibia" },
  { code: "NR", dialCode: "+674",  name: "Nauru" },
  { code: "NP", dialCode: "+977",  name: "Nepal" },
  { code: "NL", dialCode: "+31",   name: "Netherlands" },
  { code: "NZ", dialCode: "+64",   name: "New Zealand" },
  { code: "NI", dialCode: "+505",  name: "Nicaragua" },
  { code: "NE", dialCode: "+227",  name: "Niger" },
  { code: "NG", dialCode: "+234",  name: "Nigeria" },
  { code: "KP", dialCode: "+850",  name: "North Korea" },
  { code: "MK", dialCode: "+389",  name: "North Macedonia" },
  { code: "NO", dialCode: "+47",   name: "Norway" },
  { code: "OM", dialCode: "+968",  name: "Oman" },
  { code: "PK", dialCode: "+92",   name: "Pakistan" },
  { code: "PW", dialCode: "+680",  name: "Palau" },
  { code: "PA", dialCode: "+507",  name: "Panama" },
  { code: "PG", dialCode: "+675",  name: "Papua New Guinea" },
  { code: "PY", dialCode: "+595",  name: "Paraguay" },
  { code: "PE", dialCode: "+51",   name: "Peru" },
  { code: "PH", dialCode: "+63",   name: "Philippines" },
  { code: "PL", dialCode: "+48",   name: "Poland" },
  { code: "PT", dialCode: "+351",  name: "Portugal" },
  { code: "QA", dialCode: "+974",  name: "Qatar" },
  { code: "RO", dialCode: "+40",   name: "Romania" },
  { code: "RU", dialCode: "+7",    name: "Russia" },
  { code: "RW", dialCode: "+250",  name: "Rwanda" },
  { code: "KN", dialCode: "+1869", name: "Saint Kitts and Nevis" },
  { code: "LC", dialCode: "+1758", name: "Saint Lucia" },
  { code: "VC", dialCode: "+1784", name: "Saint Vincent and the Grenadines" },
  { code: "WS", dialCode: "+685",  name: "Samoa" },
  { code: "SM", dialCode: "+378",  name: "San Marino" },
  { code: "ST", dialCode: "+239",  name: "Sao Tome and Principe" },
  { code: "SA", dialCode: "+966",  name: "Saudi Arabia" },
  { code: "SN", dialCode: "+221",  name: "Senegal" },
  { code: "RS", dialCode: "+381",  name: "Serbia" },
  { code: "SC", dialCode: "+248",  name: "Seychelles" },
  { code: "SL", dialCode: "+232",  name: "Sierra Leone" },
  { code: "SG", dialCode: "+65",   name: "Singapore" },
  { code: "SK", dialCode: "+421",  name: "Slovakia" },
  { code: "SI", dialCode: "+386",  name: "Slovenia" },
  { code: "SB", dialCode: "+677",  name: "Solomon Islands" },
  { code: "SO", dialCode: "+252",  name: "Somalia" },
  { code: "ZA", dialCode: "+27",   name: "South Africa" },
  { code: "KR", dialCode: "+82",   name: "South Korea" },
  { code: "SS", dialCode: "+211",  name: "South Sudan" },
  { code: "ES", dialCode: "+34",   name: "Spain" },
  { code: "LK", dialCode: "+94",   name: "Sri Lanka" },
  { code: "SD", dialCode: "+249",  name: "Sudan" },
  { code: "SR", dialCode: "+597",  name: "Suriname" },
  { code: "SE", dialCode: "+46",   name: "Sweden" },
  { code: "CH", dialCode: "+41",   name: "Switzerland" },
  { code: "SY", dialCode: "+963",  name: "Syria" },
  { code: "TW", dialCode: "+886",  name: "Taiwan" },
  { code: "TJ", dialCode: "+992",  name: "Tajikistan" },
  { code: "TZ", dialCode: "+255",  name: "Tanzania" },
  { code: "TH", dialCode: "+66",   name: "Thailand" },
  { code: "TL", dialCode: "+670",  name: "Timor-Leste" },
  { code: "TG", dialCode: "+228",  name: "Togo" },
  { code: "TO", dialCode: "+676",  name: "Tonga" },
  { code: "TT", dialCode: "+1868", name: "Trinidad and Tobago" },
  { code: "TN", dialCode: "+216",  name: "Tunisia" },
  { code: "TR", dialCode: "+90",   name: "Turkey" },
  { code: "TM", dialCode: "+993",  name: "Turkmenistan" },
  { code: "TV", dialCode: "+688",  name: "Tuvalu" },
  { code: "UG", dialCode: "+256",  name: "Uganda" },
  { code: "UA", dialCode: "+380",  name: "Ukraine" },
  { code: "AE", dialCode: "+971",  name: "UAE" },
  { code: "GB", dialCode: "+44",   name: "United Kingdom" },
  { code: "US", dialCode: "+1",    name: "United States" },
  { code: "UY", dialCode: "+598",  name: "Uruguay" },
  { code: "UZ", dialCode: "+998",  name: "Uzbekistan" },
  { code: "VU", dialCode: "+678",  name: "Vanuatu" },
  { code: "VE", dialCode: "+58",   name: "Venezuela" },
  { code: "VN", dialCode: "+84",   name: "Vietnam" },
  { code: "YE", dialCode: "+967",  name: "Yemen" },
  { code: "ZM", dialCode: "+260",  name: "Zambia" },
  { code: "ZW", dialCode: "+263",  name: "Zimbabwe" },
];

// Primary IANA time zone(s) for each country, used only as a fallback when
// the browser locale carries no region subtag -- doesn't need to be
// exhaustive for multi-zone countries, just enough to make a reasonable guess.
const TIMEZONE_COUNTRY_MAP = {
  'Asia/Kabul': 'AF', 'Europe/Tirane': 'AL', 'Africa/Algiers': 'DZ', 'Europe/Andorra': 'AD',
  'Africa/Luanda': 'AO', 'America/Antigua': 'AG', 'America/Argentina/Buenos_Aires': 'AR',
  'Asia/Yerevan': 'AM', 'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Australia/Brisbane': 'AU',
  'Australia/Perth': 'AU', 'Australia/Adelaide': 'AU', 'Australia/Darwin': 'AU', 'Australia/Hobart': 'AU',
  'Europe/Vienna': 'AT', 'Asia/Baku': 'AZ', 'America/Nassau': 'BS', 'Asia/Bahrain': 'BH',
  'Asia/Dhaka': 'BD', 'America/Barbados': 'BB', 'Europe/Minsk': 'BY', 'Europe/Brussels': 'BE',
  'America/Belize': 'BZ', 'Africa/Porto-Novo': 'BJ', 'Asia/Thimphu': 'BT', 'America/La_Paz': 'BO',
  'Europe/Sarajevo': 'BA', 'Africa/Gaborone': 'BW', 'America/Sao_Paulo': 'BR', 'America/Manaus': 'BR',
  'America/Fortaleza': 'BR', 'America/Recife': 'BR', 'America/Bahia': 'BR', 'America/Belem': 'BR',
  'America/Cuiaba': 'BR', 'America/Rio_Branco': 'BR', 'Asia/Brunei': 'BN', 'Europe/Sofia': 'BG',
  'Africa/Ouagadougou': 'BF', 'Africa/Bujumbura': 'BI', 'Atlantic/Cape_Verde': 'CV', 'Asia/Phnom_Penh': 'KH',
  'Africa/Douala': 'CM', 'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'America/Edmonton': 'CA',
  'America/Winnipeg': 'CA', 'America/Halifax': 'CA', 'America/St_Johns': 'CA', 'America/Regina': 'CA',
  'Africa/Bangui': 'CF', 'Africa/Ndjamena': 'TD', 'America/Santiago': 'CL', 'Asia/Shanghai': 'CN',
  'Asia/Urumqi': 'CN', 'America/Bogota': 'CO', 'Indian/Comoro': 'KM', 'Africa/Brazzaville': 'CG',
  'America/Costa_Rica': 'CR', 'Europe/Zagreb': 'HR', 'America/Havana': 'CU', 'Asia/Nicosia': 'CY',
  'Europe/Prague': 'CZ', 'Europe/Copenhagen': 'DK', 'Africa/Djibouti': 'DJ', 'America/Dominica': 'DM',
  'America/Santo_Domingo': 'DO', 'America/Guayaquil': 'EC', 'Africa/Cairo': 'EG', 'America/El_Salvador': 'SV',
  'Africa/Malabo': 'GQ', 'Africa/Asmara': 'ER', 'Europe/Tallinn': 'EE', 'Africa/Mbabane': 'SZ',
  'Africa/Addis_Ababa': 'ET', 'Pacific/Fiji': 'FJ', 'Europe/Helsinki': 'FI', 'Europe/Paris': 'FR',
  'Africa/Libreville': 'GA', 'Africa/Banjul': 'GM', 'Asia/Tbilisi': 'GE', 'Europe/Berlin': 'DE',
  'Africa/Accra': 'GH', 'Europe/Athens': 'GR', 'America/Grenada': 'GD', 'America/Guatemala': 'GT',
  'Africa/Conakry': 'GN', 'Africa/Bissau': 'GW', 'America/Guyana': 'GY', 'America/Port-au-Prince': 'HT',
  'America/Tegucigalpa': 'HN', 'Europe/Budapest': 'HU', 'Atlantic/Reykjavik': 'IS', 'Asia/Kolkata': 'IN',
  'Asia/Jakarta': 'ID', 'Asia/Makassar': 'ID', 'Asia/Jayapura': 'ID', 'Asia/Tehran': 'IR',
  'Asia/Baghdad': 'IQ', 'Europe/Dublin': 'IE', 'Asia/Jerusalem': 'IL', 'Europe/Rome': 'IT',
  'America/Jamaica': 'JM', 'Asia/Tokyo': 'JP', 'Asia/Amman': 'JO', 'Asia/Almaty': 'KZ',
  'Asia/Aqtobe': 'KZ', 'Africa/Nairobi': 'KE', 'Pacific/Tarawa': 'KI', 'Asia/Kuwait': 'KW',
  'Asia/Bishkek': 'KG', 'Asia/Vientiane': 'LA', 'Europe/Riga': 'LV', 'Asia/Beirut': 'LB',
  'Africa/Maseru': 'LS', 'Africa/Monrovia': 'LR', 'Africa/Tripoli': 'LY', 'Europe/Vaduz': 'LI',
  'Europe/Vilnius': 'LT', 'Europe/Luxembourg': 'LU', 'Indian/Antananarivo': 'MG', 'Africa/Blantyre': 'MW',
  'Asia/Kuala_Lumpur': 'MY', 'Asia/Kuching': 'MY', 'Indian/Maldives': 'MV', 'Africa/Bamako': 'ML',
  'Europe/Malta': 'MT', 'Pacific/Majuro': 'MH', 'Africa/Nouakchott': 'MR', 'Indian/Mauritius': 'MU',
  'America/Mexico_City': 'MX', 'America/Tijuana': 'MX', 'America/Cancun': 'MX', 'America/Monterrey': 'MX',
  'Pacific/Chuuk': 'FM', 'Europe/Chisinau': 'MD', 'Europe/Monaco': 'MC', 'Asia/Ulaanbaatar': 'MN',
  'Europe/Podgorica': 'ME', 'Africa/Casablanca': 'MA', 'Africa/Maputo': 'MZ', 'Asia/Yangon': 'MM',
  'Africa/Windhoek': 'NA', 'Pacific/Nauru': 'NR', 'Asia/Kathmandu': 'NP', 'Europe/Amsterdam': 'NL',
  'Pacific/Auckland': 'NZ', 'America/Managua': 'NI', 'Africa/Niamey': 'NE', 'Africa/Lagos': 'NG',
  'Asia/Pyongyang': 'KP', 'Europe/Skopje': 'MK', 'Europe/Oslo': 'NO', 'Asia/Muscat': 'OM',
  'Asia/Karachi': 'PK', 'Pacific/Palau': 'PW', 'America/Panama': 'PA', 'Pacific/Port_Moresby': 'PG',
  'America/Asuncion': 'PY', 'America/Lima': 'PE', 'Asia/Manila': 'PH', 'Europe/Warsaw': 'PL',
  'Europe/Lisbon': 'PT', 'Asia/Qatar': 'QA', 'Europe/Bucharest': 'RO', 'Europe/Moscow': 'RU',
  'Asia/Yekaterinburg': 'RU', 'Asia/Novosibirsk': 'RU', 'Asia/Krasnoyarsk': 'RU', 'Asia/Irkutsk': 'RU',
  'Asia/Vladivostok': 'RU', 'Asia/Kamchatka': 'RU', 'Africa/Kigali': 'RW', 'America/St_Kitts': 'KN',
  'America/St_Lucia': 'LC', 'America/St_Vincent': 'VC', 'Pacific/Apia': 'WS', 'Europe/San_Marino': 'SM',
  'Africa/Sao_Tome': 'ST', 'Asia/Riyadh': 'SA', 'Africa/Dakar': 'SN', 'Europe/Belgrade': 'RS',
  'Indian/Mahe': 'SC', 'Africa/Freetown': 'SL', 'Asia/Singapore': 'SG', 'Europe/Bratislava': 'SK',
  'Europe/Ljubljana': 'SI', 'Pacific/Guadalcanal': 'SB', 'Africa/Mogadishu': 'SO', 'Africa/Johannesburg': 'ZA',
  'Asia/Seoul': 'KR', 'Africa/Juba': 'SS', 'Europe/Madrid': 'ES', 'Asia/Colombo': 'LK',
  'Africa/Khartoum': 'SD', 'America/Paramaribo': 'SR', 'Europe/Stockholm': 'SE', 'Europe/Zurich': 'CH',
  'Asia/Damascus': 'SY', 'Asia/Taipei': 'TW', 'Asia/Dushanbe': 'TJ', 'Africa/Dar_es_Salaam': 'TZ',
  'Asia/Bangkok': 'TH', 'Asia/Dili': 'TL', 'Africa/Lome': 'TG', 'Pacific/Tongatapu': 'TO',
  'America/Port_of_Spain': 'TT', 'Africa/Tunis': 'TN', 'Europe/Istanbul': 'TR', 'Asia/Ashgabat': 'TM',
  'Pacific/Funafuti': 'TV', 'Africa/Kampala': 'UG', 'Europe/Kyiv': 'UA', 'Europe/Kiev': 'UA',
  'Asia/Dubai': 'AE', 'Europe/London': 'GB', 'America/New_York': 'US', 'America/Chicago': 'US',
  'America/Denver': 'US', 'America/Los_Angeles': 'US', 'America/Anchorage': 'US', 'Pacific/Honolulu': 'US',
  'America/Montevideo': 'UY', 'Asia/Tashkent': 'UZ', 'Pacific/Efate': 'VU', 'America/Caracas': 'VE',
  'Asia/Ho_Chi_Minh': 'VN', 'Asia/Aden': 'YE', 'Africa/Lusaka': 'ZM', 'Africa/Harare': 'ZW',
};

const DEFAULT_DIAL_CODE = "+91";

// Time-zone-first: it mirrors the OS's location setting. Browser/OS
// language (navigator.language) is a poor proxy for country -- e.g. an
// India-based Windows install with an English (UK) language pack reports
// "en-GB", which would otherwise outrank the correct "Asia/Kolkata" zone.
// Locale region is kept only as a fallback for the rare case a time zone
// isn't resolvable at all.
const guessDialCode = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const countryCode = TIMEZONE_COUNTRY_MAP[tz];
    if (countryCode) {
      const match = COUNTRY_CODES.find((c) => c.code === countryCode);
      if (match) return match.dialCode;
    }
  } catch (e) {
    // ignore timezone lookup errors
  }

  try {
    const locales = (typeof navigator !== "undefined" && navigator.languages?.length)
      ? navigator.languages
      : [typeof navigator !== "undefined" ? navigator.language : null].filter(Boolean);

    for (const loc of locales) {
      const region = loc?.split("-").find((p) => /^[A-Z]{2}$/.test(p));
      if (region) {
        const match = COUNTRY_CODES.find((c) => c.code === region);
        if (match) return match.dialCode;
      }
    }
  } catch (e) {
    // ignore locale parsing errors
  }

  return DEFAULT_DIAL_CODE;
};

// Full name → { first, last }: first whitespace-delimited token is the first
// name, everything after it (if any) is the last name.
const parseNameParts = (fullName) => {
  const parts = (fullName || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { first: "", last: "" };
  if (parts.length === 1) return { first: parts[0], last: "" };
  return { first: parts[0], last: parts.slice(1).join(" ") };
};

// "+91 94903 46327" → { dial: "+91", number: "9490346327" }. Falls back to
// { dial: null, number: <digits> } when no leading + / known dial code.
const splitDialCode = (rawPhone) => {
  if (!rawPhone) return { dial: null, number: "" };
  const trimmed = String(rawPhone).trim();
  const digits = trimmed.replace(/\D/g, "");
  if (trimmed.startsWith("+") && digits) {
    const match = [...COUNTRY_CODES]
      .sort((a, b) => b.dialCode.length - a.dialCode.length)
      .find((c) => digits.startsWith(c.dialCode.slice(1)));
    if (match) return { dial: match.dialCode, number: digits.slice(match.dialCode.length - 1) };
  }
  return { dial: null, number: digits };
};

function CountryCodeSelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    if (!open) setSearch("");
  }, [open]);

  const filtered = search.trim()
    ? COUNTRY_CODES.filter((c) => (
      c.name.toLowerCase().includes(search.trim().toLowerCase()) ||
      c.dialCode.includes(search.trim())
    ))
    : COUNTRY_CODES;

  return (
    <div ref={ref} style={{ position: "relative", flexShrink: 0 }}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        style={{
          border: "none",
          borderRight: "1px solid #E4E9F0",
          background: "#F7F9FC",
          padding: "0 8px",
          height: "100%",
          fontSize: "13px",
          color: "#525B66",
          cursor: "pointer",
          outline: "none",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          minWidth: "68px",
          borderRadius: "4px",
        }}
      >
        {value} <span style={{ fontSize: "9px", marginTop: "1px" }}>▾</span>
      </button>
      {open && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            background: "#fff",
            border: "1px solid #E4E9F0",
            borderRadius: "6px",
            zIndex: 200,
            width: "260px",
            maxWidth: "80vw",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <input
            type="text"
            placeholder="Search country..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
            style={{
              border: "none",
              borderBottom: "1px solid #E4E9F0",
              outline: "none",
              padding: "10px 12px",
              fontSize: "13px",
              color: "#2D3748",
              background: "#F7F9FC",
              flexShrink: 0,
            }}
          />
          <div style={{ maxHeight: "200px", overflowY: "auto" }}>
            {filtered.map((c) => (
              <button
                key={c.code}
                type="button"
                onClick={() => { onChange(c.dialCode); setOpen(false); }}
                style={{
                  display: "block",
                  width: "100%",
                  padding: "7px 12px",
                  border: "none",
                  background: c.dialCode === value ? "#FFF5F9" : "transparent",
                  textAlign: "left",
                  cursor: "pointer",
                  fontSize: "13px",
                  color: "#2D3748",
                  whiteSpace: "nowrap",
                  borderRadius: "4px",
                }}
              >
                {c.dialCode} — {c.name}
              </button>
            ))}
            {filtered.length === 0 && (
              <div style={{ padding: "12px", fontSize: "13px", color: "#8A9199" }}>No matches</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const CandidateUpload = () => {
  const [resume, setResume] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resumeError, setResumeError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackSeverity, setSnackSeverity] = useState("error");
  const [snackMessage, setSnackMessage] = useState("");
  const [isHover, setIsHover] = useState(false);
  const [dialCode, setDialCode] = useState(() => guessDialCode());
  const [brandingLoading, setBrandingLoading] = useState(false);
  const [jobFetchFailed, setJobFetchFailed] = useState(false);
  // processingState: null | 'evaluating' -- once the pre-screening link arrives we navigate away immediately
  const [processingState, setProcessingState] = useState(null);
  const [jobCandidateId, setJobCandidateId] = useState(null);
  const [closeFailed, setCloseFailed] = useState(false);
  const { jobId } = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const resumeInputRef = useRef(null);
  const dialCodeTouchedRef = useRef(false);

  const socketRef = useRef(null);
  const reconnectTimerRef = useRef(null);
  const reconnectAttemptsRef = useRef(0);
  const intentionalCloseRef = useRef(null);
  const evaluationTimeoutRef = useRef(null);
  const MAX_RECONNECT_ATTEMPTS = 10;
  const EVALUATION_TIMEOUT_MS = 10000;

  const job = useSelector((state) => state.jobs.latestJob);
  const tenantBranding = useSelector((state) => state.qualifyQuestions?.tenantBranding);
  const isWhiteLabel = Boolean(tenantBranding?.is_white_label);
  const logoSrc = isWhiteLabel && tenantBranding?.logo
    ? tenantBranding.logo
    : "/images/gappeoai-sm-logo.svg";
  // "mandatory" | "optional" | "skip" -- controls whether the resume field is required, optional, or hidden
  const cvMode = job?.web_chat_settings?.cv_mode || "mandatory";

  useEffect(() => {
    const fetchJob = async () => {
      if (jobId) {
        setLoading(true);
        // fetchJobById resolves to the job on success and undefined on failure
        const fetchedJob = await dispatch(fetchJobById(jobId));
        setJobFetchFailed(!fetchedJob);
        setLoading(false);
      }
    };
    fetchJob();
  }, []);

  useEffect(() => {
    const token = searchParams.get("t");
    if (!token) return;
    setBrandingLoading(true);
    dispatch(fetchTenantBranding(token)).finally(() => setBrandingLoading(false));
  }, [searchParams, dispatch]);

  useEffect(() => {
    if (isWhiteLabel && tenantBranding?.colour) {
      document.documentElement.style.setProperty("--qualify-accent-color", tenantBranding.colour);
    }
  }, [isWhiteLabel, tenantBranding?.colour]);

  // Locale/time zone are device settings and can be wrong (e.g. a
  // US-provisioned laptop physically in India), so they're only used as an
  // instant placeholder above. IP geolocation reflects where the candidate
  // is actually connecting from, so it overrides that placeholder once it
  // resolves -- unless the candidate has already picked a country manually.
  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 4000);

    fetch("https://ipapi.co/json/", { signal: controller.signal })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (dialCodeTouchedRef.current) return;
        const countryCode = data?.country_code || data?.country;
        if (!countryCode) return;
        const match = COUNTRY_CODES.find((c) => c.code === countryCode);
        if (match) setDialCode(match.dialCode);
      })
      .catch(() => {
        // network blocked/rate-limited/etc -- keep the locale/timezone guess
      })
      .finally(() => clearTimeout(timeoutId));

    return () => {
      controller.abort();
      clearTimeout(timeoutId);
    };
  }, []);

  // WebSocket: after applying, wait for the pre-screening notification event
  useEffect(() => {
    const baseUrl = process.env.REACT_APP_WS_URL;
    if (!jobCandidateId || !baseUrl) return;

    intentionalCloseRef.current = false;

    // Carry the branding token forward so the next page can pick up the cached branding.
    const brandingToken = searchParams.get("t");
    const withBrandingToken = (path) =>
      brandingToken ? `${path}?t=${encodeURIComponent(brandingToken)}` : path;

    // If the pre-screening notification hasn't arrived within this window, stop
    // waiting and show the candidate a thank-you screen instead of an endless spinner.
    evaluationTimeoutRef.current = setTimeout(() => {
      setProcessingState("done");
    }, EVALUATION_TIMEOUT_MS);

    const connect = () => {
      if (intentionalCloseRef.current) return;

      const wsUrl = `${baseUrl}?job_candidate_id=${encodeURIComponent(jobCandidateId)}`;
      let socket;
      try {
        socket = new WebSocket(wsUrl);
      } catch (err) {
        // Malformed URL / blocked by browser or network policy -- fall back to the
        // evaluation timeout instead of crashing the whole page (no ErrorBoundary upstream).
        console.error("Failed to open WebSocket:", err);
        return;
      }
      socketRef.current = socket;

      socket.onopen = () => {
        reconnectAttemptsRef.current = 0;
      };

      socket.onmessage = (event) => {
        try {
          const parsed = JSON.parse(event.data);
          if (parsed.type === "notification" && parsed.data) {
            const eventType = parsed.data?.event_type;
            const metaData = parsed.data?.meta_data;
            const preScreenId = metaData?.data?.prescreen?.pre_screen_id;
            if (eventType === "pre_screening.scheduled" && preScreenId) {
              clearTimeout(evaluationTimeoutRef.current);
              navigate(withBrandingToken(`/pre-screen/${preScreenId}`));
              return;
            }

            // Job has no pre-screening: the candidate goes straight to whichever
            // stage comes next (same handling as qualifyQuestions.js).
            const stageId = metaData?.job_candidate_hiring_id;
            const isDynamicVoiceCall = metaData?.data?.stage?.dynamic_voice_call || false;
            // Dynamic voice call stages fire "assigned" first, then "scheduled" once
            // the call link is ready — ignore "assigned" for them and wait for "scheduled".
            const isPendingDynamicAssignment =
              eventType === "telephonic_screening.assigned" && isDynamicVoiceCall;
            const eligibleEventTypes = [
              "telephonic_screening.scheduled",
              "telephonic_screening.assigned",
              "ai_assessments.scheduled",
              "video_interview.scheduled",
            ];
            if (!stageId || !eligibleEventTypes.includes(eventType) || isPendingDynamicAssignment) return;

            clearTimeout(evaluationTimeoutRef.current);
            const assessmentLink = metaData?.data?.assessment?.assessment_link;
            const videoCallId = metaData?.data?.video_call?.video_call_id;
            const voiceCallLink = metaData?.data?.dynamic_voice_call?.voice_call_link;

            if (eventType === "ai_assessments.scheduled" && assessmentLink) {
              window.location.href = assessmentLink;
            } else if (eventType === "video_interview.scheduled" && videoCallId) {
              navigate(withBrandingToken(`/video-call/${videoCallId}`));
            } else if (
              eventType === "telephonic_screening.scheduled" &&
              isDynamicVoiceCall &&
              voiceCallLink
            ) {
              try {
                const voiceCallUrl = new URL(voiceCallLink);
                navigate(voiceCallUrl.pathname + voiceCallUrl.search);
              } catch (err) {
                window.location.href = voiceCallLink;
              }
            } else {
              navigate(withBrandingToken(`/hiring-stage/${stageId}`));
            }
          }
        } catch (err) {
          console.error("Error parsing WebSocket message:", err);
        }
      };

      socket.onclose = () => {
        if (intentionalCloseRef.current) return;
        if (reconnectAttemptsRef.current >= MAX_RECONNECT_ATTEMPTS) {
          console.warn("WebSocket: max reconnect attempts reached");
          return;
        }
        const delay = Math.min(30000, 1000 * Math.pow(2, reconnectAttemptsRef.current));
        reconnectAttemptsRef.current += 1;
        reconnectTimerRef.current = setTimeout(connect, delay);
      };

      socket.onerror = () => {
        socket.close();
      };
    };

    connect();

    return () => {
      intentionalCloseRef.current = true;
      clearTimeout(reconnectTimerRef.current);
      clearTimeout(evaluationTimeoutRef.current);
      if (socketRef.current) socketRef.current.close();
    };
  }, [jobCandidateId, navigate, searchParams]);

  const handleResumeClick = () => {
    resumeInputRef.current.click();
  };

  const handlePdfUpload = (e) => {
    const f = e.target.files[0];
    if (f) {
      setResume(f);
      setResumeError(false);
    }
  };

  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    email: Yup.string().required("Email ID is required"),
    phone_number: Yup.string().required("Phone number is required"),
  });

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      resume: null,
    },
    validationSchema,
    onSubmit: async (values, formikHelpers) => {
      const { setSubmitting, resetForm } = formikHelpers;

      if (cvMode === "mandatory" && !resume) {
        setResumeError(true);
        return;
      } else {
        setResumeError(false);
      }

      const formData = new FormData();
      formData.append("name", `${values.first_name} ${values.last_name}`);
      formData.append("email", values.email);
      formData.append("phone_number", `${dialCode}${values.phone_number}`);
      if (resume) formData.append("resume", resume);
      const recruiterCode = searchParams.get("rc");
      if (recruiterCode) formData.append("recruiter_code", recruiterCode);
      // "Invitation to apply" email links carry ?name=&email=&phone=; anything else is a direct apply.
      const fromInvite = ["name", "email", "phone"].some((key) => searchParams.get(key));
      formData.append("source", fromInvite ? CANDIDATE_SOURCE.INVITED_CANDIDATE : CANDIDATE_SOURCE.APPLY_PAGE);
    try {
        setSubmitting(true);
        const response = await dispatch(applyForJob(jobId, formData));
        setSubmitting(false);

          if (response?.success) {
            resetForm();
            setResume(null);
            setResumeError(false);
            const candidateId = response?.data?.id || response?.data?.job_candidate_id;
            if (candidateId) {
              setJobCandidateId(candidateId);
              setProcessingState("evaluating");
            } else {
              showSnack(response?.message || "Applying for job successful", "success");
            }
          } else {
            showSnack(response?.message || "Applying for job failed", "error");
          }
        } catch (error) {
          showSnack(error?.message || "Unexpected error occurred Applying for job failed", "error");
        }
    },
  });

  // Prefill from the invite-link query params (?name=&email=&phone=) — the
  // "Invitation to apply" email links straight here with the candidate's
  // details. Full name splits into First / Last name; the phone's leading
  // dial code is matched against the country list and set on the selector.
  const prefilledRef = useRef(false);
  useEffect(() => {
    if (prefilledRef.current) return;
    const nameParam = searchParams.get("name");
    const emailParam = searchParams.get("email");
    const phoneParam = searchParams.get("phone");
    if (!nameParam && !emailParam && !phoneParam) return;
    prefilledRef.current = true;

    if (nameParam) {
      const { first, last } = parseNameParts(nameParam);
      if (first) formik.setFieldValue("first_name", first, false);
      if (last) formik.setFieldValue("last_name", last, false);
    }
    if (emailParam) formik.setFieldValue("email", emailParam, false);
    if (phoneParam) {
      const { dial, number } = splitDialCode(phoneParam);
      if (dial) {
        dialCodeTouchedRef.current = true;
        setDialCode(dial);
      }
      if (number) formik.setFieldValue("phone_number", number, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const snackClosed = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackOpen(false);
  };

  const showSnack = (message, severity = "error") => {
    setSnackMessage(message);
    setSnackSeverity(severity);
    setSnackOpen(true);
  };

  // Browsers only let a script close a tab it opened itself (via window.open).
  // A tab reached via a direct link/redirect can't be closed programmatically --
  // so attempt it, and if the tab is still around a moment later, tell the
  // user to close it manually instead of leaving a button that does nothing.
  const handleCloseWindow = () => {
    window.close();
    setTimeout(() => setCloseFailed(true), 300);
  };

  if (loading || brandingLoading) {
    return (
      <div className="job-summary">
        <div className="loading-overlay">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading job summary...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="candidate-upload">
      <div className="candidate-upload-header">
        <div className="candidate-upload-title">
          <div className="company-logo">
            <img src={logoSrc} alt="" width={60} height={60} />
          </div>
          <div className="position-details">
            <h3>{job?.title}</h3>
            <p className="position-subtitle">
              {[job?.company_name, job?.job_type?.name, job?.experience_required && `${job.experience_required} yrs exp`]
                .filter(Boolean)
                .join(" | ")}
            </p>
            {job?.country?.name && (
              <p className="position-location job-qualifications">
                <strong>Location:</strong> {[job?.city?.name, job?.country?.name].filter(Boolean).join(", ")}
              </p>
            )}
            {job?.qualifications && (
              <p className="job-qualifications">
                <strong>Job qualifications:</strong> {job.qualifications}
              </p>
            )}
            <div className="requirements">
              {job?.skills?.slice(0, 2).map((skills, index) => (
                <p className="candidate-skills" key={index}>
                  {skills}
                </p>
              ))}
              {job?.skills?.length > 2 && (
                <p className="candidate-skills more-skills">
                  +{job.skills.length - 2} more
                  <div className="skills-popup">
                    {job.skills.slice(2).map((s, idx, arr) => (
                      <span key={idx}>
                        {s}
                        {idx < arr.length - 1 && ", "}
                      </span>
                    ))}
                  </div>
                </p>
              )}
              {job?.salary && (
                <p style={{ background: "#DEF7EC", color: "#03543F" }}>
                  {job?.salary}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="candidate-upload-body">
        {processingState === "evaluating" ? (
          <div style={{ textAlign: "center", padding: "60px 24px" }}>
            <div className="spinner-border" role="status" style={{ color: "var(--qualify-accent-color, #F75891)" }}>
              <span className="visually-hidden">Processing...</span>
            </div>
            <h4 style={{ marginTop: "16px", fontFamily: "inter, sans-serif", color: "#111928" }}>
              Processing your application...
            </h4>
            <p style={{ color: "#6b7280" }}>Please wait while we set up your next step.</p>
          </div>
        ) : processingState === "done" ? (
          <div className="thank-you-screen">
            <div className="d-flex justify-content-center">
              <img src="/images/thankyou-icon.gif" alt="" />
            </div>
            <h2>Application Received</h2>
            <p>We're still processing your application. You will receive an email notification for the next steps.</p>
            {closeFailed ? (
              <p className="close-fallback-text">You can now safely close this browser tab.</p>
            ) : (
              <div className="d-flex justify-content-center">
                <button className="close-btn" onClick={handleCloseWindow}>Close Window</button>
              </div>
            )}
          </div>
        ) : (
          <div className="job-details-body">
            <form onSubmit={formik.handleSubmit}>
              <div className="form-section">
                <label>
                  First Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  name="first_name"
                  placeholder="First Name"
                  value={formik.values.first_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.first_name && formik.errors.first_name
                      ? "input-error"
                      : ""
                  }
                />
              </div>

              <div className="form-section">
                <label>
                  Last Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  name="last_name"
                  placeholder="Last Name"
                  value={formik.values.last_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.last_name && formik.errors.last_name
                      ? "input-error"
                      : ""
                  }
                />
              </div>

              <div className="form-section">
                <label>
                  Phone number <span style={{ color: "red" }}>*</span>
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                    border: `1px solid ${formik.touched.phone_number && formik.errors.phone_number ? "red" : "#E4E9F0"}`,
                    borderRadius: "6px",
                    overflow: "visible",
                    height: "40px !important",
                  }}
                >
                  <CountryCodeSelect
                    value={dialCode}
                    onChange={(code) => { dialCodeTouchedRef.current = true; setDialCode(code); }}
                  />
                  <input
                    type="tel"
                    name="phone_number"
                    placeholder="Phone Number"
                    value={formik.values.phone_number}
                    onChange={(e) => {
                      const val = e.target.value.replace(/[^\d\s\-()]/g, "");
                      formik.setFieldValue("phone_number", val);
                    }}
                    onBlur={formik.handleBlur}
                    style={{
                      border: "none",
                      outline: "none",
                      flex: 1,
                      padding: "0 10px",
                      fontSize: "13px",
                      background: "transparent",
                      minWidth: 0,
                      borderRadius: "0px",
                    }}
                  />
                </div>
                {formik.touched.phone_number && formik.errors.phone_number && (
                  <p className="text-danger" style={{ fontSize: "12px", marginTop: "4px" }}>
                    {formik.errors.phone_number}
                  </p>
                )}
              </div>

              <div className="form-section">
                <label>
                  Email ID <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.email && formik.errors.email
                      ? "input-error"
                      : ""
                  }
                />
              </div>

              {cvMode !== "skip" && (
                <div className="form-section">
                  <label>
                    Upload resume {cvMode === "mandatory" && <span style={{ color: "red" }}>*</span>}
                  </label>
                  <div className="resume-upload">
                    <img src="/images/upload-gray.svg" alt="" />
                    <p>
                      <strong>Click to upload</strong> or drag and drop
                    </p>
                    <p>
                      <strong>Supported format: .word,.pdf</strong>
                    </p>
                    <button
                      className="resume-button"
                      type="button"
                      onClick={handleResumeClick}
                      disabled={formik.isSubmitting}
                      onMouseEnter={() => {
                        setIsHover(true);
                      }}
                      onMouseLeave={() => {
                        setIsHover(false);
                      }}
                    >
                      {isHover ? (
                        <img src="/images/cart-plus-icon-wight.svg" alt="" />
                      ) : (
                        <img src="/images/cart-plus-icon.svg" alt="" />
                      )}
                      &nbsp;&nbsp;Browse File
                    </button>
                    <input
                      ref={resumeInputRef}
                      type="file"
                      name="resume"
                      accept=".pdf,.docx"
                      onChange={handlePdfUpload}
                      style={{ display: "none" }}
                    />
                    {resume && (
                      <p>
                        Selected: <strong>{resume.name}</strong>
                      </p>
                    )}
                    {resumeError ? (
                      <p className="text-danger">Please upload your resume (PDF or Word)</p>
                    ) : null}
                  </div>
                </div>
              )}

              <button
                className="btn mt-3"
                type="submit"
                disabled={formik.isSubmitting || jobFetchFailed}
                style={{
                  borderRadius: "16px",
                  ...(jobFetchFailed && {
                    background: "#D1D5DB",
                    borderColor: "#D1D5DB",
                    color: "#6B7280",
                    cursor: "not-allowed",
                  }),
                }}
              >
                Continue
              </button>
            </form>
          </div>
        )}
      </div>
      <Dialog
        className="schedule-loader"
        open={formik.isSubmitting}
        onClose={() => {}}
        PaperProps={{
          sx: {
            boxShadow: "none",
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={snackOpen}
        autoHideDuration={5000}
        onClose={snackClosed}
      >
        <Alert
          onClose={snackClosed}
          severity={snackSeverity}
          sx={{ width: "100%" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CandidateUpload;
